"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ws4Webview = void 0;
var tslib_1 = require("tslib");
var Subscribe_1 = require("../../shared-utils/Subscribe");
var WebScoketState_1 = require("../typings/WebScoketState");
var WebSocketCloseOptions_1 = require("../typings/WebSocketCloseOptions");
var WebSocketEvent_1 = require("../typings/WebSocketEvent");
var Ws4Webview = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Ws4Webview, _super);
    function Ws4Webview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._state = null;
        /**
         * @description 注册ws接通事件回调
         * @param listener 事件回调函数
         * @param once 是否只执行一次
         * @returns
         */
        _this.onOpen = function (listener, once) {
            return once ? _this.once(WebSocketEvent_1.WebSocketEvent.open, listener) : _this.on(WebSocketEvent_1.WebSocketEvent.open, listener);
        };
        /**
         * @description 注册一次ws接通事件回调
         * @param listener 事件回调函数
         */
        _this.onceOpen = function (listener) { return _this.onOpen(listener, true); };
        /**
         * @description 移除ws接通事件回调
         * @param listener 事件回调函数
         * @returns
         */
        _this.offOpen = function (listener) {
            return _this.hasListener(WebSocketEvent_1.WebSocketEvent.open) && _this.off(WebSocketEvent_1.WebSocketEvent.open, listener);
        };
        /**
         * @description 注册ws消息事件回调
         * @param listener 事件回调函数
         * @param once 是否只执行一次
         * @returns
         */
        _this.onMessage = function (listener, once) {
            return once ? _this.once(WebSocketEvent_1.WebSocketEvent.message, listener) : _this.on(WebSocketEvent_1.WebSocketEvent.message, listener);
        };
        /**
         * @description 注册一次ws消息事件回调
         * @param listener 事件回调函数
         */
        _this.onceMessage = function (listener) { return _this.onMessage(listener, true); };
        /**
         * @description 移除ws接通事件回调
         * @param listener 事件回调函数
         * @returns
         */
        _this.offMessage = function (listener) {
            return _this.hasListener(WebSocketEvent_1.WebSocketEvent.message) && _this.off(WebSocketEvent_1.WebSocketEvent.message, listener);
        };
        /**
         * @description 注册ws错误事件回调
         * @param listener 事件回调函数
         * @param once 是否只执行一次
         * @returns
         */
        _this.onError = function (listener, once) {
            return once ? _this.once(WebSocketEvent_1.WebSocketEvent.error, listener) : _this.on(WebSocketEvent_1.WebSocketEvent.error, listener);
        };
        /**
         * @description 注册一次ws消息事件回调
         * @param listener 事件回调函数
         */
        _this.onceError = function (listener) { return _this.onError(listener, true); };
        /**
         * @description 移除ws接通事件回调
         * @param listener 事件回调函数
         * @returns
         */
        _this.offError = function (listener) {
            return _this.hasListener(WebSocketEvent_1.WebSocketEvent.error) && _this.off(WebSocketEvent_1.WebSocketEvent.error, listener);
        };
        /**
         * @description 注册ws错误事件回调
         * @param listener 事件回调函数
         * @param once 是否只执行一次
         * @returns
         */
        _this.onClose = function (listener, once) {
            return once ? _this.once(WebSocketEvent_1.WebSocketEvent.close, listener) : _this.on(WebSocketEvent_1.WebSocketEvent.close, listener);
        };
        /**
         * @description 注册一次ws消息事件回调
         * @param listener 事件回调函数
         */
        _this.onceClose = function (listener) { return _this.onClose(listener, true); };
        /**
         * @description 移除ws接通事件回调
         * @param listener 事件回调函数
         * @returns
         */
        _this.offClose = function (listener) {
            return _this.hasListener(WebSocketEvent_1.WebSocketEvent.close) && _this.off(WebSocketEvent_1.WebSocketEvent.close, listener);
        };
        return _this;
    }
    Object.defineProperty(Ws4Webview.prototype, "readyState", {
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 连接ws
     * @param options
     */
    Ws4Webview.prototype.connect = function (options) {
        var _this = this;
        if (this._state === WebScoketState_1.WebScoketState.CONNECTING || this._state === WebScoketState_1.WebScoketState.OPEN)
            return Promise.reject("\u5DF2\u5B58\u5728\u4E00\u4E2A\u8FDE\u63A5\u4E2D\u6216\u6253\u5F00\u72B6\u6001\u7684websocket\u5B9E\u4F8B" /* WsAlreadyExists */);
        return new Promise(function (resolve, reject) {
            var url = options.url;
            if (!url)
                throw new Error("\u975E\u6CD5\u7684websocket\u94FE\u63A5" /* WsUrlInvalid */);
            _this._wsOptions = options;
            _this._state = WebScoketState_1.WebScoketState.CONNECTING;
            _this._wsTask = new WebSocket(url);
            _this.registerEventHandler();
            _this.handleConnected();
            _this.onceOpen(function () { return resolve(true); });
            _this.onceError(function (err) { return reject(err); });
        });
    };
    /**
     * 重连websocket
     * @returns
     */
    Ws4Webview.prototype.reconnect = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                this.close(WebSocketCloseOptions_1.WebSocketCloseOptions.reconnect);
                if (this._wsOptions)
                    this.connect(this._wsOptions);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @description 发送消息
     * @param data 消息体
     */
    Ws4Webview.prototype.send = function (data) {
        var _this = this;
        try {
            if (this._wsTask && this.readyState === WebScoketState_1.WebScoketState.OPEN) {
                this._wsTask.send(data);
            }
            else if (this._wsTask && this.readyState === WebScoketState_1.WebScoketState.CONNECTING) {
                this.once(WebSocketEvent_1.WebSocketEvent.open, function () { var _a; return (_a = _this._wsTask) === null || _a === void 0 ? void 0 : _a.send(data); });
            }
            else {
                this.once(WebSocketEvent_1.WebSocketEvent.open, function () { return _this.send(data); });
                this.reconnect();
            }
        }
        catch (e) {
            this.once(WebSocketEvent_1.WebSocketEvent.open, function () { return _this.send(data); });
            this.reconnect();
        }
    };
    /**
     * @description 手动关闭ws
     * @param options 关闭ws的配置参数
     */
    Ws4Webview.prototype.close = function (options) {
        var _a;
        this._state = WebScoketState_1.WebScoketState.CLOSING;
        (_a = this._wsTask) === null || _a === void 0 ? void 0 : _a.close(options.code, options.reason);
    };
    /**
     * 处理连接后的事件绑定
     */
    Ws4Webview.prototype.handleConnected = function () {
        var _this = this;
        this.onceOpen(function () { return (_this._state = WebScoketState_1.WebScoketState.OPEN); });
        this.onClose(function () { return (_this._state = WebScoketState_1.WebScoketState.CLOSED); });
    };
    /**
     * 注册websocket事件
     */
    Ws4Webview.prototype.registerEventHandler = function () {
        var _this = this;
        var _a, _b, _c, _d;
        (_a = this._wsTask) === null || _a === void 0 ? void 0 : _a.addEventListener(WebSocketEvent_1.WebSocketEvent.open, function (ev) { return _this.emit(WebSocketEvent_1.WebSocketEvent.open, ev); });
        (_b = this._wsTask) === null || _b === void 0 ? void 0 : _b.addEventListener(WebSocketEvent_1.WebSocketEvent.message, function (result) {
            var data = result.data;
            try {
                if (typeof result.data === 'string') {
                    data = JSON.parse(result.data);
                }
            }
            catch (e) {
                /** 不可序列化的数据不用处理 */
            }
            _this.emit(WebSocketEvent_1.WebSocketEvent.message, data);
        });
        (_c = this._wsTask) === null || _c === void 0 ? void 0 : _c.addEventListener(WebSocketEvent_1.WebSocketEvent.close, function (ev) { return _this.emit(WebSocketEvent_1.WebSocketEvent.close, ev); });
        (_d = this._wsTask) === null || _d === void 0 ? void 0 : _d.addEventListener(WebSocketEvent_1.WebSocketEvent.error, function (ev) { return _this.emit(WebSocketEvent_1.WebSocketEvent.error, ev); });
    };
    return Ws4Webview;
}(Subscribe_1.Subscribe));
exports.Ws4Webview = Ws4Webview;
exports.default = Ws4Webview;
//# sourceMappingURL=ws.js.map